import React, { ButtonHTMLAttributes, Children } from "react";
import classNames from "classnames";
import '../../scss/button.scss';

// import "../../scss/buton.scss"

type ButtonVariant = "primary" | "dark" | "green";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>{
    variant?: ButtonVariant;
    fullWidth?:boolean;
    disabled?: false;
}

export const Button: React.FC<ButtonProps> = ({
    children, variant, fullWidth, className, disabled, ...rest
}) => {
    const classes = classNames(
        "btn",
        `btn--${variant}`,
        {
            "btn--fullWidth": fullWidth,
            "btn--disabled": disabled,
        },
        "button",
        className
    );
    
    return <button {...rest} type={"button"} className={classes} disabled={disabled}>{children}</button>
};